export default {
  "brand.name": "Basetao Spreadsheet",
  "nav.home": "Inicio",
  "nav.guide": "Guía de compra",
  "nav.review": "Reseña",
  "nav.shipping": "Envío",
  "nav.qc": "QC",
  "nav.articles": "Artículos",
  "cta.explore": "Explorar Basetao Spreadsheet",
  "cta.buyNow": "Comprar Ahora",
  "cta.brand": "Basetao Spreadsheet",
  "cta.readGuide": "Leer la Guía Completa",
  "cta.backHome": "Volver al Inicio",
  "cta.visitMain": "Visitar Nuestro Sitio Principal",
  "footer.tagline": "Recursos, guías y herramientas de investigación de productos independientes sobre Basetao Spreadsheet.",
  "footer.disclaimer": "Este es un recurso informativo independiente. La información puede cambiar y debe verificarse de forma independiente. No estamos afiliados, respaldados ni conectados con ningún servicio de terceros mencionado.",
  "footer.rights": "Todos los derechos reservados.",
  "footer.resources": "Recursos",
  "footer.legal": "Legal",
  "lang.en": "English",
  "lang.fr": "Français",
  "lang.de": "Deutsch",
  "lang.es": "Español",
  "lang.pt": "Português",
};